export const ErrorStatuses = {
  NoAuth: 'NoAuth',
  TokenExpires: 'TokenExpires',
  NoAccessRights: 'NoAccessRights',
};
